import Component from 'flarum/common/Component';
import TwoFactorGrid from './TwoFactorGrid';
export default class TwoFactorSettings extends Component {
  oninit(vnode) {
    super.oninit(vnode);

    // this.twoFactorEnabled = this.attrs.user.twoFactorEnabled();
    // this.canDisableTwoFactor = this.attrs.user.canDisable2FA();
    // this.loading = false;
  }
  view() {
    return m("div", null, m(TwoFactorGrid, {
      user: this.attrs.user
    }));
  }
}
flarum.reg.add('ianm-twofactor', 'forum/components/TwoFactorSettings', TwoFactorSettings);